import React from 'react';
import styles from './SingleMetricCardWithIcon.module.scss';

interface SingleMetricCardWithIconProps {
  title: string;
  backgroundColor: string;
  detail: string;
  textColor: string;
  icon: string;
  legend?: string;
  hasClassname?: boolean;
}

const SingleMetricCardWithIcon: React.FC<SingleMetricCardWithIconProps> = ({
  title,
  backgroundColor,
  detail,
  textColor,
  icon,
  legend,
  hasClassname,
}) => {
  return (
    <div className={styles.card} style={{ backgroundColor }}>
      <div className={styles.iconContainer}>
        <img
          src={icon}
          alt="cardIcon"
          className={hasClassname && styles.firstCard}
        />
      </div>
      <div className={styles.content}>
        <div className={styles.titleContainer}>
          <span className={styles.title} style={{ color: textColor }}>
            {title}
          </span>
        </div>
        <div className={styles.detailContainer}>
          <span className={styles.detail} style={{ color: textColor }}>
            {detail}
          </span>
          {legend && (
            <span className={styles.legend} style={{ color: textColor }}>
              {legend}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleMetricCardWithIcon;
